
import {
  Breadcrumbs,
  Container,
  Divider,
  Grid,
  Link,
} from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import AiChatbot from '../components/AiChatBot/AiChatBot';
import Page from '../components/Page';  



export default function Chatbot(props) {
  return (
    <Page title="AI-Chatbot">
      
      <Container maxWidth={false}>
        {/* <div role="presentation" style={{ cursor: 'pointer', paddingBottom: '20px' }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/dashboard/home">
              <HomeOutlinedIcon />
            </Link>
            <Link underline="hover" color="inherit" href="/dashboard/ai-chatbot">
              AI-Chatbot
            </Link>
          </Breadcrumbs>
        </div> */}
        <Divider/>
        <Grid item lg={12} sm={12} xs={12} md={12} xl={12} sx={{py:1}} >
       <AiChatbot />
        </Grid>

        <Grid container item xs={12} sm={12} md={12} lg={12}>
          <Outlet />
        </Grid>

      </Container>
    </Page>
  );
}
